export const isObfuscatedData = (value) => {
  // eg. **********@ring.com
  const regex = /\*{10}/;
  return regex.test(value);
};

export const getRBACRoleDescription = (roleId) => {
  switch (roleId) {
    case "owner":
      return "Owner";
    case "installer":
      return "Installer";
    case "location_manager":
      return "Advanced";
    case "partial_access":
      return "Standard";
    case "view_only":
      return "Limited";
    case "shared_user":
      return "Shared";
  }
  return "N/A";
};
